import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as RegionalServices from "../../../../service/RegionalServices";
import changeToSentecesText from "../../../../util/changeToSentecesText";
import { Input } from "antd";
import { ChevronDownDDS } from "../../../../asset";

const DropdownSearchPostalCode = ({
  setValueDDS,
  children,
  valueDDS,
  className,
  togglerClassName,
  placeholder,
  urbanVillageId,
  ...attrs
}) => {
  const { token } = useSelector((state) => state.auth);

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    limit: 100,
    filter: `urban_village_id eq ${urbanVillageId}`,
  });
  const [listData, setListData] = useState([]);
  const [dataSelected, setDataSelected] = useState();
  const [searchKeyword, setSearchkeyword] = useState("");
  const [prevUrbanVillageId, setPrevUrbanVillageId] = useState(urbanVillageId);

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const getListData = useCallback(
    async (newParams) => {
      const { ok, list } = await RegionalServices.dropdownPostalCode(
        token,
        newParams
      );

      if (ok && list !== null && list.length !== 0) {
        const newData = list.map((el) => {
          return {
            id: el.id,
            value: `${el.code}`,
          };
        });

        setListData(newData);
      } else {
        setListData([]);
      }
    },
    [token]
  );

  const onClickDataSelected = useCallback(
    (data) => {
      setDataSelected(data);
      setIsShowDropdownContent(false);
      setParams({
        page: 1,
        limit: 100,
        filter: `urban_village_id eq ${urbanVillageId}`,
      });
      setSearchkeyword("");
      setValueDDS(data?.id);
    },
    [setValueDDS, urbanVillageId]
  );

  const onChangeSearch = useCallback(
    (val) => {
      if (!val) {
        const resetParams = {
          page: 1,
          limit: 100,
          filter: `urban_village_id eq ${urbanVillageId}`,
        };
        setParams(resetParams);
        setSearchkeyword("");
        return;
      }
      const newParams = {
        ...params,
        filter: `urban_village_id eq ${urbanVillageId}, code lk ${val}`,
      };
      setParams(newParams);
      setSearchkeyword(val);
    },
    [params, urbanVillageId]
  );

  useEffect(() => {
    if (!urbanVillageId || urbanVillageId === null) {
      return;
    }
    if (!searchKeyword) {
      const newParams = {
        ...params,
        filter: `urban_village_id eq ${urbanVillageId}`,
      };
      getListData(newParams);
      return;
    }
    getListData(params);
  }, [getListData, params, searchKeyword, urbanVillageId]);

  useEffect(() => {
    if (!valueDDS || valueDDS === null) {
      setDataSelected();
      return;
    }
    if (valueDDS && listData.length) {
      const dataSelected = listData.filter((el) => el.id === valueDDS);
      setDataSelected(dataSelected[0]);
    }
    return;
  }, [listData, valueDDS]);

  useEffect(() => {
    if (!urbanVillageId || !prevUrbanVillageId) {
      setDataSelected();
      setValueDDS();
      return;
    }
    if (urbanVillageId !== null && prevUrbanVillageId !== null) {
      if (urbanVillageId !== prevUrbanVillageId) {
        setDataSelected();
        setValueDDS();
      }
    }

    setPrevUrbanVillageId(urbanVillageId);
  }, [prevUrbanVillageId, setValueDDS, urbanVillageId]);

  return (
    <div
      className={"dropdown".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className={"w-full border border-gray-200 flex justify-between px-[6px] rounded-md h-[40px] items-center".concat(
          urbanVillageId ? " bg-white-100" : " bg-gray-1000 cursor-not-allowed"
        )}
        onClick={urbanVillageId ? togglerDropdownContent : undefined}
      >
        <span
          className={"font-roboto text-xl text-black-300 font-medium px-2 truncate".concat(
            !dataSelected ? " text-opacity-50" : ""
          )}
        >
          {dataSelected
            ? changeToSentecesText(dataSelected?.value)
            : placeholder}
        </span>
        <img src={ChevronDownDDS} alt="img-chevron-down" />
      </button>
      <div></div>
      <div
        className={"dropdown-menu".concat(
          isShowDropdownContent ? " active mt-5" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="mt-2 px-2">
          <Input
            onChange={(evt) => {
              onChangeSearch(evt.target.value);
            }}
            value={searchKeyword}
            className="mb-2"
            placeholder="Search By Postal Code"
            size="large"
          />
        </div>
        <ul className="overflow-auto max-h-[300px]">
          {listData && listData.length !== 0 ? (
            listData.map((el, index) => (
              <li
                key={index}
                className="dropdown-item truncate"
                onClick={() => {
                  onClickDataSelected(el);
                }}
              >
                {changeToSentecesText(el?.value)}
              </li>
            ))
          ) : (
            <div className="flex w-full justify-center text-gray-600 font-bold text-base mb-5">
              No Data
            </div>
          )}
        </ul>
      </div>
    </div>
  );
};

export default DropdownSearchPostalCode;
